import React, { Suspense } from 'react'
import { StyleSheet, View } from 'react-native'
import { Spacing } from 'zens-storybook'
import { useNumberParams, usePaginationParam, useSortParam } from 'zens-router'
import {
  CompanyInfo,
  CompanyOccupancyColors,
  LocationTable,
  CompanyVitality,
  CompanyHeader,
  LayoutHeader,
  CompanyRegularSync,
  CompanyWebhookSettings,
  CompanySubscriptions,
} from '@dms/component'
import { AccessType } from 'zens-store'
import { usePermissions } from '@dms/hook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.L,
  },
  locations: {
    marginTop: Spacing.XL,
  },
  info: {
    marginTop: Spacing.M,
  },
})

const CompanyDetail = () => {
  const [{ companyId }] = useNumberParams()
  const [pagination, setPagination] = usePaginationParam()
  const [sort, setSort] = useSortParam({ field: 'name', direction: 'asc' })
  const { hasPermission } = usePermissions(companyId)

  return (
    <View style={styles.container}>
      <Suspense fallback={<LayoutHeader.Skeleton breadcrumb title />}>
        <CompanyHeader companyId={companyId} />
      </Suspense>
      <View style={styles.content}>
        <Suspense fallback={<CompanyInfo.Skeleton />}>
          <CompanyInfo companyId={companyId} />
        </Suspense>
        <Suspense fallback={<CompanyVitality.Skeleton style={styles.info} />}>
          <CompanyVitality companyId={companyId} style={styles.info} />
        </Suspense>
        {hasPermission(AccessType.Read, 'settings') && (
          <>
            <Suspense fallback={<CompanyOccupancyColors.Skeleton style={styles.info} />}>
              <CompanyOccupancyColors companyId={companyId} style={styles.info} />
            </Suspense>
            <CompanyWebhookSettings companyId={companyId} style={styles.info} />
            <CompanySubscriptions companyId={companyId} style={styles.info} />
            <Suspense fallback={<CompanyRegularSync.Skeleton style={styles.info} />}>
              <CompanyRegularSync companyId={companyId} style={styles.info} />
            </Suspense>
          </>
        )}
        {hasPermission(AccessType.Read, 'location') && (
          <Suspense fallback={<LocationTable.Skeleton style={styles.locations} />}>
            <LocationTable
              style={styles.locations}
              companyId={companyId}
              pagination={pagination}
              onPaginationChange={setPagination}
              sort={sort}
              onSortChange={setSort}
            />
          </Suspense>
        )}
      </View>
    </View>
  )
}

export default CompanyDetail
